import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traducciones
const resources = {
  es: {
    translation: {
      // Header
      "nav.home": "Inicio",
      "nav.benefits": "Beneficios",
      "nav.solutions": "Soluciones",
      "nav.contact": "Contáctanos",
      
      // Hero Section
      "hero.badge": "SISTEMA INTELIGENTE",
      "hero.title": "Tu Hogar,",
      "hero.title.highlight": "Más Inteligente",
      "hero.description": "Controla la iluminación, clima y seguridad de tu hogar desde cualquier lugar. Experimenta el futuro de la automatización residencial.",
      "hero.cta.whatsapp": "Contactar por WhatsApp",
      "hero.cta.demo": "Ver Demostración",
      "hero.security": "100% Seguro",
      
      // Smart Home Visualizer
      "visualizer.badge": "Demostración Interactiva en Vivo",
      "visualizer.title": "Experimenta la",
      "visualizer.title.highlight": "Domótica Real",
      "visualizer.description": "Interactúa con controles reales y observa cómo la automatización transforma cada espacio",
      "visualizer.system.active": "Sistema Activo",
      "visualizer.lights": "Luces",
      "visualizer.lights.on": "Luces ON",
      "visualizer.lights.off": "Luces OFF",
      "visualizer.curtains": "Cortinas",
      "visualizer.curtains.open": "Cortinas Abiertas",
      "visualizer.curtains.closed": "Cortinas Cerradas",
      "visualizer.climate": "Clima",
      "visualizer.security": "Seguridad",
      "visualizer.security.active": "Seguro ✓",
      "visualizer.security.inactive": "Inactivo",
      "visualizer.stats.lighting": "Iluminación",
      "visualizer.stats.environment": "Ambiente",
      "visualizer.stats.day": "Día",
      "visualizer.stats.night": "Noche",
      "visualizer.stats.temperature": "Temperatura",
      "visualizer.stats.security": "Seguridad",
      "visualizer.stats.active": "Activa",
      "visualizer.stats.off": "OFF",
      "visualizer.stats.on": "ON",
      "visualizer.footer": "Haz clic en los iconos flotantes para controlar cada función de tu hogar inteligente",
      
      // Benefits Page
      "benefits.badge": "AUTOMATIZACIÓN PROFESIONAL",
      "benefits.title": "Transforma Tu Hogar en un",
      "benefits.title.highlight": "Espacio Inteligente",
      "benefits.description": "Descubre cómo la automatización moderna mejora tu calidad de vida, ahorra energía y aumenta la seguridad de tu hogar",
      "benefits.cta": "Solicitar Consulta Gratuita",
      
      // Benefit Cards
      "benefit.comfort.title": "Confort Total",
      "benefit.comfort.desc": "Control absoluto de iluminación, temperatura y ambiente desde cualquier dispositivo",
      
      "benefit.security.title": "Seguridad Avanzada",
      "benefit.security.desc": "Monitoreo en tiempo real, alertas instantáneas y control de accesos inteligente",
      
      "benefit.energy.title": "Ahorro Energético",
      "benefit.energy.desc": "Optimización automática del consumo eléctrico que reduce hasta 30% tus facturas",
      
      "benefit.voice.title": "Control por Voz",
      "benefit.voice.desc": "Compatible con Alexa, Google Home y Siri para control manos libres",
      
      "benefit.scenes.title": "Escenas Personalizadas",
      "benefit.scenes.desc": "Configura ambientes perfectos con un solo toque: Cine, Fiesta, Dormir, Despertar",
      
      "benefit.remote.title": "Acceso Remoto",
      "benefit.remote.desc": "Controla tu hogar desde cualquier lugar del mundo con conexión segura",
      
      // Why Choose Section
      "why.badge": "¿POR QUÉ ELEGIRNOS?",
      "why.title": "Experiencia y Tecnología de",
      "why.title.highlight": "Primera Clase",
      
      "why.experience.title": "10+ Años de Experiencia",
      "why.experience.desc": "Líderes en automatización residencial con cientos de proyectos exitosos",
      
      "why.certified.title": "Técnicos Certificados",
      "why.certified.desc": "Equipo profesional con certificaciones internacionales en domótica",
      
      "why.support.title": "Soporte 24/7",
      "why.support.desc": "Asistencia técnica disponible en todo momento para tu tranquilidad",
      
      "why.warranty.title": "Garantía Extendida",
      "why.warranty.desc": "2 años de garantía en equipos y mano de obra instalada",
      
      // How It Works
      "how.badge": "PROCESO SIMPLE",
      "how.title": "En Solo",
      "how.title.highlight": "4 Pasos",
      
      "how.step1.title": "Consulta Gratuita",
      "how.step1.desc": "Evaluamos tu hogar y diseñamos la solución perfecta sin costo",
      
      "how.step2.title": "Propuesta Personalizada",
      "how.step2.desc": "Recibe un plan detallado con costos transparentes y plazos claros",
      
      "how.step3.title": "Instalación Profesional",
      "how.step3.desc": "Nuestro equipo instala todo el sistema sin interrumpir tu rutina",
      
      "how.step4.title": "Capacitación y Soporte",
      "how.step4.desc": "Te enseñamos a usar tu hogar inteligente y damos soporte continuo",
      
      // Contact Section
      "contact.badge": "CONTÁCTANOS",
      "contact.title": "Comienza Tu",
      "contact.title.highlight": "Transformación Hoy",
      "contact.description": "Completa el formulario y un especialista se comunicará contigo en menos de 24 horas",
      
      "contact.form.title": "Envíanos un Mensaje",
      "contact.form.name": "Nombre completo",
      "contact.form.email": "Correo electrónico",
      "contact.form.phone": "Teléfono",
      "contact.form.message": "Cuéntanos sobre tu proyecto",
      "contact.form.submit": "Enviar Mensaje",
      "contact.form.sending": "Enviando...",
      
      "contact.success.title": "¡Mensaje Enviado!",
      "contact.success.message": "Gracias por contactarnos. Un especialista se comunicará contigo pronto.",
      "contact.success.close": "Cerrar",
      
      "contact.info.phone": "Teléfono",
      "contact.info.whatsapp": "WhatsApp",
      "contact.info.email": "Email",
      "contact.info.email.response": "Respuesta en 24 horas",
      "contact.info.hours": "Horario",
      "contact.info.hours.weekday": "Lun - Vie: 9:00 AM - 6:00 PM",
      "contact.info.hours.saturday": "Sáb: 10:00 AM - 2:00 PM",
      
      // Footer
      "footer.tagline": "Transformando hogares en espacios inteligentes",
      "footer.rights": "Todos los derechos reservados.",
      "footer.links.title": "Enlaces Rápidos",
      "footer.links.automations": "Automatizaciones",
      "footer.links.benefits": "Beneficios",
      "footer.links.solutions": "Soluciones",
      "footer.services.title": "Servicios",
      "footer.services.lighting": "Iluminación Inteligente",
      "footer.services.climate": "Climatización",
      "footer.services.security": "Seguridad y Vigilancia",
      "footer.services.access": "Control de Acceso",
      "footer.services.entertainment": "Entretenimiento",
      "footer.services.voice": "Integración por Voz",
      "footer.contact.title": "Contacto",
      
      // Features
      "features.badge": "NUESTRAS SOLUCIONES",
      "features.title": "Automatización Completa",
      "features.description": "Desde iluminación hasta seguridad, controlamos cada aspecto de tu hogar con tecnología de vanguardia",
      
      // Benefits Simple
      "benefits.simple.badge": "BENEFICIOS",
      "benefits.simple.title": "¿Por Qué Elegir Comfort Home?",
      "benefits.simple.description": "Invierte en tecnología que mejora tu calidad de vida y el valor de tu propiedad",
      
      // Solutions
      "solutions.badge": "SOLUCIONES",
      "solutions.title": "Para Cada Necesidad",
      "solutions.description": "Soluciones personalizadas para hogares, oficinas y negocios",
      "solutions.cta": "Más Información",
      
      // Features Items
      "features.item1.title": "Iluminación Inteligente",
      "features.item1.description": "Control total de la iluminación de tu hogar desde cualquier lugar. Ajusta intensidad, color y crea escenas personalizadas.",
      "features.item1.benefit1": "Ahorro energético hasta 60%",
      "features.item1.benefit2": "Control por voz",
      "features.item1.benefit3": "Automatización horaria",
      
      "features.item2.title": "Climatización",
      "features.item2.description": "Mantén la temperatura perfecta en cada habitación. Sistema inteligente que aprende tus preferencias y optimiza el consumo.",
      "features.item2.benefit1": "Reducción de costos 40%",
      "features.item2.benefit2": "Confort personalizado",
      "features.item2.benefit3": "Control por zonas",
      
      "features.item3.title": "Seguridad Avanzada",
      "features.item3.description": "Protección 24/7 con cámaras inteligentes, sensores de movimiento y alertas en tiempo real a tu smartphone.",
      "features.item3.benefit1": "Monitoreo en tiempo real",
      "features.item3.benefit2": "Reconocimiento facial",
      "features.item3.benefit3": "Alertas instantáneas",
      
      "features.item4.title": "Entretenimiento",
      "features.item4.description": "Sistema de audio y video multihabitación. Controla toda tu experiencia de entretenimiento desde una sola app.",
      "features.item4.benefit1": "Audio en toda la casa",
      "features.item4.benefit2": "Streaming integrado",
      "features.item4.benefit3": "Control universal",
      
      "features.item5.title": "Cortinas y Persianas",
      "features.item5.description": "Automatización de cortinas, persianas y ventanas. Programación por horarios o control manual desde tu dispositivo.",
      "features.item5.benefit1": "Control solar automático",
      "features.item5.benefit2": "Privacidad programable",
      "features.item5.benefit3": "Integración con clima",
      
      "features.item6.title": "Control por Voz",
      "features.item6.description": "Integración completa con Alexa, Google Assistant y Siri. Controla tu hogar con comandos de voz naturales.",
      "features.item6.benefit1": "Manos libres total",
      "features.item6.benefit2": "Comandos personalizados",
      "features.item6.benefit3": "Rutinas inteligentes",
      
      // Benefits Items
      "benefits.item1.title": "Ahorro Energético",
      "benefits.item1.description": "Reduce tu consumo eléctrico hasta un 60% con automatización inteligente y gestión eficiente de recursos.",
      "benefits.item2.title": "Confort Total",
      "benefits.item2.description": "Ambiente perfecto en cada momento. Tu hogar se adapta automáticamente a tus necesidades y preferencias.",
      "benefits.item3.title": "Seguridad",
      "benefits.item3.description": "Protección continua y alertas inteligentes.",
      "benefits.item4.title": "Valorización",
      "benefits.item4.description": "Incrementa el valor de tu propiedad hasta un 20% con tecnología de automatización de última generación.",
      
      // Solutions Items
      "solutions.item1.category": "RESIDENCIAL",
      "solutions.item1.title": "Casas y Departamentos",
      "solutions.item1.description": "Soluciones completas para espacios residenciales. Desde estudios hasta residencias de lujo.",
      "solutions.item1.feature1": "Paquetes personalizables",
      "solutions.item1.feature2": "Instalación profesional",
      "solutions.item1.feature3": "Garantía extendida",
      "solutions.item2.category": "EMPRESARIAL",
      "solutions.item2.title": "Oficinas y Comercios",
      "solutions.item2.description": "Automatización para espacios comerciales que optimiza costos y mejora la experiencia del cliente.",
      "solutions.item2.feature1": "Control centralizado",
      "solutions.item2.feature2": "Gestión energética",
      "solutions.item2.feature3": "Seguridad corporativa",
      "solutions.item3.category": "HOTELERÍA",
      "solutions.item3.title": "Hoteles y Resorts",
      "solutions.item3.description": "Experiencia premium para huéspedes con control total desde habitaciones hasta áreas comunes.",
      "solutions.item3.feature1": "Check-in inteligente",
      "solutions.item3.feature2": "Personalización por huésped",
      "solutions.item3.feature3": "Gestión masiva",
      
      // FAQ
      "faq.badge": "FAQ",
      "faq.title": "Preguntas Frecuentes",
      "faq.description": "Resuelve tus dudas sobre automatización del hogar",
      "faq.cta.title": "¿Aún tienes dudas?",
      "faq.cta.description": "Nuestro equipo está listo para ayudarte",
      "faq.cta.button": "Contacta a un Especialista",
      "faq.q1.question": "¿Qué incluye la instalación de Comfort Home?",
      "faq.q1.answer": "Nuestra instalación incluye evaluación técnica inicial, diseño personalizado del sistema, instalación profesional de todos los dispositivos, configuración completa, capacitación de uso, y soporte técnico durante 12 meses. También incluimos garantía de 3 años en equipos.",
      "faq.q2.question": "¿Cuánto tiempo toma instalar el sistema completo?",
      "faq.q2.answer": "Para un departamento estándar (80-120m²), la instalación toma entre 3-5 días laborales. Para casas más grandes o proyectos comerciales, el tiempo puede extenderse a 2-3 semanas dependiendo de la complejidad. Realizamos un cronograma detallado en la consulta inicial.",
      "faq.q3.question": "¿Puedo controlar mi casa desde cualquier lugar?",
      "faq.q3.answer": "Sí, absolutamente. Nuestra aplicación móvil te permite controlar todos los aspectos de tu hogar desde cualquier parte del mundo con conexión a internet. Además, recibes notificaciones en tiempo real sobre eventos importantes como alertas de seguridad o cambios de estado.",
      "faq.q4.question": "¿El sistema es compatible con mi casa actual?",
      "faq.q4.answer": "Sí, nuestros sistemas se adaptan a cualquier tipo de propiedad, tanto construcciones nuevas como edificaciones existentes. Durante la evaluación inicial, nuestros técnicos determinan la mejor estrategia de instalación para minimizar obras y maximizar funcionalidad.",
      "faq.q5.question": "¿Qué pasa si hay un corte de internet?",
      "faq.q5.answer": "Nuestros sistemas cuentan con funcionalidad local, por lo que los automatismos programados siguen funcionando incluso sin internet. Los controles manuales por switches inteligentes también permanecen operativos. Cuando se restablece la conexión, todo se sincroniza automáticamente.",
    }
  },
  en: {
    translation: {
      // Header
      "nav.home": "Home",
      "nav.benefits": "Benefits",
      "nav.solutions": "Solutions",
      "nav.contact": "Contact",
      
      // Hero Section
      "hero.badge": "INTELLIGENT SYSTEM",
      "hero.title": "Your Home,",
      "hero.title.highlight": "Smarter",
      "hero.description": "Control your home's lighting, climate, and security from anywhere. Experience the future of residential automation.",
      "hero.cta.whatsapp": "Contact via WhatsApp",
      "hero.cta.demo": "View Demo",
      "hero.security": "100% Secure",
      
      // Smart Home Visualizer
      "visualizer.badge": "Live Interactive Demo",
      "visualizer.title": "Experience Real",
      "visualizer.title.highlight": "Home Automation",
      "visualizer.description": "Interact with real controls and see how automation transforms every space",
      "visualizer.system.active": "System Active",
      "visualizer.lights": "Lights",
      "visualizer.lights.on": "Lights ON",
      "visualizer.lights.off": "Lights OFF",
      "visualizer.curtains": "Curtains",
      "visualizer.curtains.open": "Curtains Open",
      "visualizer.curtains.closed": "Curtains Closed",
      "visualizer.climate": "Climate",
      "visualizer.security": "Security",
      "visualizer.security.active": "Secure ✓",
      "visualizer.security.inactive": "Inactive",
      "visualizer.stats.lighting": "Lighting",
      "visualizer.stats.environment": "Environment",
      "visualizer.stats.day": "Day",
      "visualizer.stats.night": "Night",
      "visualizer.stats.temperature": "Temperature",
      "visualizer.stats.security": "Security",
      "visualizer.stats.active": "Active",
      "visualizer.stats.off": "OFF",
      "visualizer.stats.on": "ON",
      "visualizer.footer": "Click the floating icons to control each smart home function",
      
      // Benefits Page
      "benefits.badge": "PROFESSIONAL AUTOMATION",
      "benefits.title": "Transform Your Home Into a",
      "benefits.title.highlight": "Smart Space",
      "benefits.description": "Discover how modern automation improves your quality of life, saves energy, and increases your home's security",
      "benefits.cta": "Request Free Consultation",
      
      // Benefit Cards
      "benefit.comfort.title": "Total Comfort",
      "benefit.comfort.desc": "Complete control of lighting, temperature, and ambiance from any device",
      
      "benefit.security.title": "Advanced Security",
      "benefit.security.desc": "Real-time monitoring, instant alerts, and intelligent access control",
      
      "benefit.energy.title": "Energy Savings",
      "benefit.energy.desc": "Automatic optimization of electricity consumption reducing bills by up to 30%",
      
      "benefit.voice.title": "Voice Control",
      "benefit.voice.desc": "Compatible with Alexa, Google Home, and Siri for hands-free control",
      
      "benefit.scenes.title": "Custom Scenes",
      "benefit.scenes.desc": "Set perfect environments with one touch: Cinema, Party, Sleep, Wake Up",
      
      "benefit.remote.title": "Remote Access",
      "benefit.remote.desc": "Control your home from anywhere in the world with secure connection",
      
      // Why Choose Section
      "why.badge": "WHY CHOOSE US?",
      "why.title": "Experience and",
      "why.title.highlight": "World-Class Technology",
      
      "why.experience.title": "10+ Years of Experience",
      "why.experience.desc": "Leaders in residential automation with hundreds of successful projects",
      
      "why.certified.title": "Certified Technicians",
      "why.certified.desc": "Professional team with international home automation certifications",
      
      "why.support.title": "24/7 Support",
      "why.support.desc": "Technical assistance available at all times for your peace of mind",
      
      "why.warranty.title": "Extended Warranty",
      "why.warranty.desc": "2-year warranty on equipment and installed labor",
      
      // How It Works
      "how.badge": "SIMPLE PROCESS",
      "how.title": "In Just",
      "how.title.highlight": "4 Steps",
      
      "how.step1.title": "Free Consultation",
      "how.step1.desc": "We evaluate your home and design the perfect solution at no cost",
      
      "how.step2.title": "Custom Proposal",
      "how.step2.desc": "Receive a detailed plan with transparent costs and clear timelines",
      
      "how.step3.title": "Professional Installation",
      "how.step3.desc": "Our team installs the entire system without disrupting your routine",
      
      "how.step4.title": "Training & Support",
      "how.step4.desc": "We teach you how to use your smart home and provide ongoing support",
      
      // Contact Section
      "contact.badge": "CONTACT US",
      "contact.title": "Start Your",
      "contact.title.highlight": "Transformation Today",
      "contact.description": "Fill out the form and a specialist will contact you within 24 hours",
      
      "contact.form.title": "Send us a Message",
      "contact.form.name": "Full name",
      "contact.form.email": "Email address",
      "contact.form.phone": "Phone",
      "contact.form.message": "Tell us about your project",
      "contact.form.submit": "Send Message",
      "contact.form.sending": "Sending...",
      
      "contact.success.title": "Message Sent!",
      "contact.success.message": "Thank you for contacting us. A specialist will reach out to you soon.",
      "contact.success.close": "Close",
      
      "contact.info.phone": "Phone",
      "contact.info.whatsapp": "WhatsApp",
      "contact.info.email": "Email",
      "contact.info.email.response": "Response within 24 hours",
      "contact.info.hours": "Hours",
      "contact.info.hours.weekday": "Mon - Fri: 9:00 AM - 6:00 PM",
      "contact.info.hours.saturday": "Sat: 10:00 AM - 2:00 PM",
      
      // Footer
      "footer.tagline": "Transforming homes into smart spaces",
      "footer.rights": "All rights reserved.",
      "footer.links.title": "Quick Links",
      "footer.links.automations": "Automations",
      "footer.links.benefits": "Benefits",
      "footer.links.solutions": "Solutions",
      "footer.services.title": "Services",
      "footer.services.lighting": "Smart Lighting",
      "footer.services.climate": "Climate Control",
      "footer.services.security": "Security & Surveillance",
      "footer.services.access": "Access Control",
      "footer.services.entertainment": "Entertainment",
      "footer.services.voice": "Voice Integration",
      "footer.contact.title": "Contact",
      
      // Features
      "features.badge": "OUR SOLUTIONS",
      "features.title": "Complete Automation",
      "features.description": "From lighting to security, we control every aspect of your home with cutting-edge technology",
      
      // Benefits Simple
      "benefits.simple.badge": "BENEFITS",
      "benefits.simple.title": "Why Choose Comfort Home?",
      "benefits.simple.description": "Invest in technology that improves your quality of life and property value",
      
      // Solutions
      "solutions.badge": "SOLUTIONS",
      "solutions.title": "For Every Need",
      "solutions.description": "Customized solutions for homes, offices, and businesses",
      "solutions.cta": "Learn More",
      
      // Features Items
      "features.item1.title": "Smart Lighting",
      "features.item1.description": "Total control of your home's lighting from anywhere. Adjust intensity, color, and create personalized scenes.",
      "features.item1.benefit1": "Energy savings up to 60%",
      "features.item1.benefit2": "Voice control",
      "features.item1.benefit3": "Time-based automation",
      
      "features.item2.title": "Climate Control",
      "features.item2.description": "Maintain perfect temperature in every room. Smart system that learns your preferences and optimizes consumption.",
      "features.item2.benefit1": "40% cost reduction",
      "features.item2.benefit2": "Personalized comfort",
      "features.item2.benefit3": "Zone control",
      
      "features.item3.title": "Advanced Security",
      "features.item3.description": "24/7 protection with smart cameras, motion sensors, and real-time alerts to your smartphone.",
      "features.item3.benefit1": "Real-time monitoring",
      "features.item3.benefit2": "Facial recognition",
      "features.item3.benefit3": "Instant alerts",
      
      "features.item4.title": "Entertainment",
      "features.item4.description": "Multi-room audio and video system. Control your entire entertainment experience from a single app.",
      "features.item4.benefit1": "Whole-house audio",
      "features.item4.benefit2": "Integrated streaming",
      "features.item4.benefit3": "Universal control",
      
      "features.item5.title": "Blinds & Shades",
      "features.item5.description": "Automation of curtains, blinds, and windows. Schedule by time or manual control from your device.",
      "features.item5.benefit1": "Automatic solar control",
      "features.item5.benefit2": "Programmable privacy",
      "features.item5.benefit3": "Climate integration",
      
      "features.item6.title": "Voice Control",
      "features.item6.description": "Complete integration with Alexa, Google Assistant, and Siri. Control your home with natural voice commands.",
      "features.item6.benefit1": "Hands-free total",
      "features.item6.benefit2": "Custom commands",
      "features.item6.benefit3": "Smart routines",
      
      // Benefits Items
      "benefits.item1.title": "Energy Savings",
      "benefits.item1.description": "Reduce your electricity consumption by up to 60% with intelligent automation and efficient resource management.",
      "benefits.item2.title": "Total Comfort",
      "benefits.item2.description": "Perfect environment at every moment. Your home automatically adapts to your needs and preferences.",
      "benefits.item3.title": "Security",
      "benefits.item3.description": "Continuous protection and intelligent alerts.",
      "benefits.item4.title": "Property Value",
      "benefits.item4.description": "Increase your property value by up to 20% with state-of-the-art automation technology.",
      
      // Solutions Items
      "solutions.item1.category": "RESIDENTIAL",
      "solutions.item1.title": "Houses & Apartments",
      "solutions.item1.description": "Complete solutions for residential spaces. From studios to luxury residences.",
      "solutions.item1.feature1": "Customizable packages",
      "solutions.item1.feature2": "Professional installation",
      "solutions.item1.feature3": "Extended warranty",
      "solutions.item2.category": "BUSINESS",
      "solutions.item2.title": "Offices & Retail",
      "solutions.item2.description": "Automation for commercial spaces that optimizes costs and improves customer experience.",
      "solutions.item2.feature1": "Centralized control",
      "solutions.item2.feature2": "Energy management",
      "solutions.item2.feature3": "Corporate security",
      "solutions.item3.category": "HOSPITALITY",
      "solutions.item3.title": "Hotels & Resorts",
      "solutions.item3.description": "Premium experience for guests with complete control from rooms to common areas.",
      "solutions.item3.feature1": "Smart check-in",
      "solutions.item3.feature2": "Guest personalization",
      "solutions.item3.feature3": "Mass management",
      
      // FAQ
      "faq.badge": "FAQ",
      "faq.title": "Frequently Asked Questions",
      "faq.description": "Find answers about home automation",
      "faq.cta.title": "Still have questions?",
      "faq.cta.description": "Our team is ready to help you",
      "faq.cta.button": "Contact a Specialist",
      "faq.q1.question": "What does Comfort Home installation include?",
      "faq.q1.answer": "Our installation includes initial technical evaluation, personalized system design, professional installation of all devices, complete configuration, usage training, and technical support for 12 months. We also include a 3-year warranty on equipment.",
      "faq.q2.question": "How long does it take to install the complete system?",
      "faq.q2.answer": "For a standard apartment (80-120m²), installation takes 3-5 business days. For larger homes or commercial projects, the time can extend to 2-3 weeks depending on complexity. We create a detailed timeline during the initial consultation.",
      "faq.q3.question": "Can I control my home from anywhere?",
      "faq.q3.answer": "Yes, absolutely. Our mobile app allows you to control all aspects of your home from anywhere in the world with an internet connection. Plus, you receive real-time notifications about important events like security alerts or status changes.",
      "faq.q4.question": "Is the system compatible with my current home?",
      "faq.q4.answer": "Yes, our systems adapt to any type of property, both new construction and existing buildings. During the initial evaluation, our technicians determine the best installation strategy to minimize work and maximize functionality.",
      "faq.q5.question": "What happens if there's an internet outage?",
      "faq.q5.answer": "Our systems have local functionality, so programmed automations continue working even without internet. Manual controls via smart switches also remain operational. When the connection is restored, everything syncs automatically.",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    lng: 'es', // idioma por defecto
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
